/**
 * Displays a banner indicating DEV or TEST environment.
 * - RED banner for DEVELOPMENT
 * - ORANGE banner for TEST
 * - Nothing for production environments
 *
 * Rendered as a child of TopBannerStack, which measures the combined height
 * of this banner alongside every other app-shell banner and exposes it as
 * --top-banner-stack-height, so fixed full-screen overlays (DocumentEditor,
 * DocumentSlidePanel, etc.) can offset their top edge below whatever
 * banners are actually showing instead of overlapping them.
 */
export default function EnvironmentBanner() {
  const hostname = window.location.hostname.toLowerCase();

  // Check if we're in dev or test environment
  // Pattern: dev.environment.seasuite.dk or test.environment.seasuite.dk
  const envMatch = hostname.match(/^(dev|test)\.environment\./);

  if (!envMatch) {
    return null; // Not a dev or test environment, don't show banner
  }

  const envType = envMatch[1].toUpperCase();
  const isDevEnv = envType === 'DEV';

  const bannerStyle = {
    backgroundColor: isDevEnv ? '#dc2626' : '#facc15', // RED for dev, vivid YELLOW for test
    color: isDevEnv ? '#ffffff' : '#000000',
    padding: '12px 16px',
    textAlign: 'center',
    fontWeight: '700',
    fontSize: '14px',
    letterSpacing: '0.5px',
    position: 'relative',
    zIndex: 40,
    width: '100%',
    pointerEvents: 'auto',
  };

  return <div style={bannerStyle}>YOU ARE IN {envType}</div>;
}
